import React, { useEffect, useState } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import Carousel from '../../baseComponents/gui/carousel/Carousel';
import { settings } from '../../../constants/carousel-settings';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import slideModalItem from './SlideModalItem';
import classNames from 'classnames';
import { useOpen } from '../../../hooks/useOpen';
import useStateControls from '../../../hooks/useStateControls';
import { useApplicationCallbacks } from '../../../providers/application-callbacks';

const SlideModal = React.forwardRef(function SlideModal(
  {
    slides = [],
    closeCallback,
    mod,
    onShow, // событие при показе модального окна
  },
  ref,
) {
  const [slide, setSlide] = useState(0);
  const { closeModal, id } = useModal();
  const { setState } = useStateControls();
  const open = useOpen();
  const callbacks = useApplicationCallbacks();

  const buttonCallbacks = {
    redirect: () => {
      setState(slides[slide].redirect);
      closeModal({ id });
    },
    toShop: () => {
      open(slides[slide].link);
      typeof slides[slide].id === 'number' && callbacks.openCustomModal(slides[slide].id);
    },
    toChallenges: () => {
      setState('challenges');
      closeModal({ id });
    },
    next: () => {
      if (slide === slides.length - 1) {
        closeCallback?.();
        closeModal(id);
        return;
      }

      setSlide((prev) => ++prev);
    },
  };

  useEffect(() => {
    onShow?.();
  }, []);

  return (
    <CustomModal>
      <div
        className={classNames('slide-modal', {
          ['slide-modal_' + mod]: mod,
          ['slide-modal_hidden-pagination']: slides.length <= 1,
        })}
        ref={ref}
      >
        <div className={'slide-modal__content'}>
          <Carousel
            key={`car-${1}`}
            settings={{
              ...settings.slideModalCarousel[1 - 1],
              onSlideChange: (swiper) => setSlide(swiper.realIndex),
            }}
            itemsData={slides}
            selectedSlide={slide}
            item={slideModalItem}
          />
          {slides.length > 1 && <div className={`slide-modal__pagination slide-modal__pagination_${1}`} />}
        </div>
        <SwitchTransition>
          <CSSTransition key={`buttons-${slide}`} timeout={300} classNames={'slide-modal__buttons'}>
            <div className={'slide-modal__buttons'}>
              {slides?.[slide]?.buttons?.map((el) => (
                <CustomButton key={el.action} {...el.attr} onClick={buttonCallbacks[el.action]} />
              ))}
            </div>
          </CSSTransition>
        </SwitchTransition>
      </div>
    </CustomModal>
  );
});
export default SlideModal;
SlideModal.propTypes = {};
